/**
 * Utility functions for AWS Integration Modal
 */

/**
 * All AWS regions (excluding "All" option)
 */
const ALL_AWS_REGIONS = [
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
  "ca-central-1",
  "ca-west-1",
  "mx-central-1",
  "us-gov-east-1",
  "us-gov-west-1",
  "eu-central-1",
  "eu-west-1",
  "eu-west-2",
  "eu-west-3",
  "eu-north-1",
  "eu-south-1",
  "eu-south-2",
  "eu-central-2",
  "eusc-de-east-1",
  "il-central-1",
  "me-south-1",
  "me-central-1",
  "af-south-1",
  "ap-northeast-1",
  "ap-northeast-2",
  "ap-northeast-3",
  "ap-southeast-1",
  "ap-southeast-2",
  "ap-south-1",
  "ap-south-2",
  "ap-southeast-3",
  "ap-southeast-4",
  "ap-southeast-5",
  "ap-east-2",
  "ap-southeast-7",
  "sa-east-1",
];

/**
 * Convert regions array, replacing "All" with actual region values
 */
export const getRegionsForApi = (regions: string[]): string[] => {
  if (regions.includes("All")) {
    return ALL_AWS_REGIONS;
  }
  return regions;
};
